import SoundIcon from "Content/images/audioPlayer/sound.svg";
import Sound2Icon from "Content/images/audioPlayer/sound2.svg";
import React, { useCallback, useEffect, useState } from "react";
import locale from "./audioDisplay.locale";
import Style from "./audioDisplay.style";
export default function AudioDisplay(props) {
    const { currentTrack, mediaRef, progressBarRef, setDuration } = props;
    const [animationDuration, setAnimationDuration] = useState("10s");
    const [isPlaying, setIsPlaying] = useState(false);
    const handleLoadedMetaData = useCallback(() => {
        var _a;
        const seconds = (_a = mediaRef.current) === null || _a === void 0 ? void 0 : _a.duration;
        setDuration(Number(seconds));
        if (progressBarRef.current != null) {
            progressBarRef.current.max = String(seconds);
        }
        setAnimationDuration(`${Math.max((seconds || 0) / 5, 10)}s`);
    }, [mediaRef]);
    const handleError = useCallback(() => {
        props.showError && props.showError(locale.LOAD_AUDIO_FAILED);
    }, [props.showError]);
    useEffect(() => {
        const sound = mediaRef.current;
        const handlePlay = () => {
            setIsPlaying(true);
        };
        const handlePause = () => {
            setIsPlaying(false);
        };
        sound === null || sound === void 0 ? void 0 : sound.addEventListener("play", handlePlay);
        sound === null || sound === void 0 ? void 0 : sound.addEventListener("pause", handlePause);
        return () => {
            sound === null || sound === void 0 ? void 0 : sound.removeEventListener("play", handlePlay);
            sound === null || sound === void 0 ? void 0 : sound.removeEventListener("pause", handlePause);
        };
    }, [mediaRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Style.Wave, { className: "overflow-hidden w-100-max mt-1_5 mb-1_5", img: SoundIcon, isPlaying: isPlaying, animationDuration: animationDuration }),
        React.createElement(Style.Wave, { className: "overflow-hidden w-100-max mb-1_5", img: Sound2Icon, isPlaying: isPlaying, animationDuration: animationDuration }),
        React.createElement("audio", { src: currentTrack, ref: mediaRef, onLoadedMetadata: handleLoadedMetaData, onError: handleError, onInvalid: handleError })));
}
